import initVueApp from "@/core.js";
const component = require(`./../views/Product2023.vue`).default;
initVueApp(component);
